import { toast } from 'sonner';

type SuccessToastProps = {
  title?: string;
  description?: string;
};

export const showSuccessToast = ({
  title,
  description,
}: SuccessToastProps = {}) => {
  toast.message(title, {
    description,
    closeButton: true,
    classNames: {
      toast: 'pl-6 pr-8 py-6',
      closeButton: 'right-0 mt-3 border-none background-none left-[inherit]',
    },
  });
};
